<template lang="pug">
  Pasajeros(@next="next" @prev="prev")
</template>

<script>

import Pasajeros from '@/components/UI/Pasajeros'

export default {
  name: 'Paso2',

  components: {
    Pasajeros
  },

  data: () => ({
  }),

  watch: {
  },

  computed: {
    total () {
      return this.$store.state.vehiculosArr.length + this.$store.state.cargasArr.length
    }
  },

  methods: {
    prev () {
      this.$store.commit('SET_PASO', 1)
      this.$router.push('/paso1')
    },

    next () {
      let n = 3
      if (this.total === 0) {
        n = 4
      }
      this.$store.commit('SET_PASO', n)
      this.$router.push('/paso' + n)
    }
  }
}

</script>

<style type="text/css">

</style>
